import { useFormik } from 'formik';
import * as Yup from 'yup';
import { HiCursorClick } from "react-icons/hi";

export default function IndustryTypeForm({ data, onSave, states, onEditFormSubmit, selectedState = '' }) {
  const formik = useFormik({
    initialValues: {
      industryType: data?.industryType || '',
      StateId: selectedState?.StateId || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      industryType: Yup.string()
        .trim()
        .required('Industry name is required')
        .min(1, 'Minimum 2 characters'),
      StateId: Yup.string().required('State is required'),
    }),
    onSubmit: (values) => {
      if (data) {
        console.log(values)
        onEditFormSubmit(values)
      } else {
        onSave(values);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
      <div>
        <label className="font-semibold">Industry Name</label>
        <input
          type="text"
          name="industryType"
          value={formik.values.industryType}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className={`border p-2 rounded w-full ${formik.touched.industryType && formik.errors.industryType ? 'border-red-500' : ''
            }`}
        />
        {formik.touched.industryType && formik.errors.industryType && (
          <p className="text-sm text-red-500">{formik.errors.industryType}</p>
        )}
      </div>

      <div>
        <label className="font-semibold">Select State</label>
        <select
          name="StateId"
          value={formik.values.StateId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className={`border p-2 rounded w-full " ${formik.touched.StateId && formik.errors.StateId ? 'border-red-500' : ''
            }`}
        >
          <option value="" disabled>Select State</option>
          {Array.isArray(states) &&
            [...states].sort((a, b) => a.State.localeCompare(b.State)).map(state => (
              <option key={state.StateId} value={state.StateId}>{state.State}</option>
            ))}
        </select>
        {formik.touched.StateId && formik.errors.StateId && (
          <p className="text-sm text-red-500">{formik.errors.StateId}</p>
        )}
      </div>
      <button
        type="submit"
        disabled={!formik.dirty}
        className={`text-white py-2 px-4 rounded flex justify-center items-center gap-2 ${!formik.dirty ? "bg-green-400" : "bg-green-800"}`}
      >
        Create
        {/* <HiCursorClick className='text-white' /> */}
      </button>
    </form>
  );
}
